/** The header's "Details" block: where it ran, its credentials and the evaluators. */

import { Fragment } from "react";
import { Link } from "react-router";
import type { ExperimentSummary } from "../types";
import { CredentialsLine } from "./credentials-line";
import { TargetLine } from "./target-line";

export function ExperimentDetails({ id, experiment: e }: { id: string; experiment: ExperimentSummary }) {
  return (
    <div id={id} className="flex flex-col gap-1.5 rounded-[9px] bg-subtle px-3.5 py-2.5">
      <TargetLine experiment={e} />
      <CredentialsLine experiment={e} />
      <dl aria-label="Scoring setup" className="flex flex-wrap gap-x-4 gap-y-1 text-xs text-muted">
        <div className="flex gap-1">
          <dt>Evaluators:</dt>
          <dd className="m-0 text-body">
            {e.evaluators.length
              ? e.evaluators.map((ev, i) => (
                  <Fragment key={ev.id}>
                    {i > 0 && ", "}
                    <Link className="link" to={`/evaluators/${ev.id}`}>
                      {ev.name}
                    </Link>
                    {ev.archive && " (archived)"}
                  </Fragment>
                ))
              : "none"}
          </dd>
        </div>
        {e.repetitions > 1 && (
          <div className="flex gap-1">
            <dt>Repetitions:</dt>
            <dd className="m-0 font-mono text-body">{e.repetitions}</dd>
          </div>
        )}
      </dl>
    </div>
  );
}
